import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import ReactPlayer from 'react-player/file';

export const PlayerWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
  box-shadow: 0 6px 19px 0 rgba(0, 0, 0, 0.15);
  border: solid 3.2px ${themeGet('colors.light-border-grey')};
  background-color: ${themeGet('colors.light-grey')};

  .react-youtube-player,
  .react-file-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const ReactPlayerFile = styled(ReactPlayer)`
  position: relative;
`;
